import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  user: {
    name: null,
    avatar: null,
    balance: 0,
  },
  clusters: [],
  menus: [],
  currentCluster: null,
  activedMenus: [
    { name: '首页', path: "/index" }
  ]
}

const getters = {
}

const actions = {

}

const mutations = {
  updateUser(state, user) {
    state.user = user
  },
  updateMenus(state, menus) {

    state.menus = menus
  },
  updateClusters(state, clusters) {
    state.clusters = clusters
  },
  updatecurrentCluster(state, currentCluster) {
    state.currentCluster = currentCluster
  },
  addActivedMenu(state, menu) {
    let pushFlag = true
    for (let _menu of state.activedMenus) {
      if (_menu.path === menu.path) {
        pushFlag = false
      }
    }
    if (pushFlag) {
      state.activedMenus.push(menu)
    }

  },
  removeActivedMenu(state, path) {
    let i = 0
    for (let menu of state.activedMenus) {
      if (path === menu.path) {
        state.activedMenus.splice(i, 1)
      }
      i++;
    }
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})




// WEBPACK FOOTER //
// ./src/workspace/store/index.js